import styled from 'styled-components';
import { Box } from '../Box/Box';

export const ScrollbarBox = styled(Box)(({ theme }) => ({
  overflowY: 'auto',
  maxHeight: 'inherit',

  '&::-webkit-scrollbar': {
    '-webkit-appearance': 'none',
    width: theme.space[8],
  },

  '&::-webkit-scrollbar-thumb': {
    borderRadius: theme.radii.medium,
    backgroundColor: theme.colors.neutral['400'],
  },
}));
